import {
  CalendarClock,
  Map,
  Send,
  ActivitySquare
} from 'lucide-react';

const whyChooseUs = [
  {
    id: 1,
    title: 'Our Methodology',
    paragraph: 'We have been using our four-step Employee Transport process for over 15 years to ensure efficiency, safety, and reliability.'
  }
];

const whyChooseUsBox = [
  {
    id: 1,
    icon: <CalendarClock className="w-8 h-8 md:w-13 md:h-13 lg:w-12 lg:h-12 text-[#153088]" />,
    title: 'Scheduling',
    paragraph: 'This involves determining employee transportation needs, including pick-up and drop-off times, locations, and any special requirements.'
  },
  {
    id: 2,
    icon: <Map className="w-8 h-8 md:w-13 md:h-13 lg:w-12 lg:h-12 text-[#162966]" />,
    title: 'Routing',
    paragraph: 'After schedules are set, this step plans efficient employee transport routes, considering traffic, distance, and available resources'
  },
  {
    id: 3,
    icon: <Send className="w-8 h-8 md:w-13 md:h-13 lg:w-12 lg:h-12 text-[#153088]" />,
    title: 'Execution',
    paragraph: 'This step implements the transport plan, ensuring timely dispatch, scheduled pickups and drop-offs, and prompt issue handling.'
  },
  {
    id: 4,
    icon: <ActivitySquare className="w-8 h-8 md:w-13 md:h-13 lg:w-12 lg:h-12 text-[#153088]" />,
    title: 'Monitoring & Feedback',
    paragraph: 'After transport is provided, monitor to identify issues and improvements. Employee and stakeholder feedback further refines the process.'
  }
];

export default function OurMethodology() {
  return (
    <div className="bg-gray-100 text-primary-content py-10">
      <div className="flex justify-center items-center max-w-[95%] md:max-w-3xl lg:max-w-6xl mx-auto">
        <div>
          {whyChooseUs.map(({ id, title, paragraph }) => (
            <div key={id}>
              <h2 className="text-lg md:text-xl lg:text-[28px] font-bold text-center">{title}</h2>
              <p className="text-xs md:text-base lg:text-lg  text-center mt-1 px-5 md:px-10 lg:px-72">
                {paragraph}
              </p>
            </div>
          ))}

          <div className="flex justify-center mt-6 md:mt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-8 px-4">
              {whyChooseUsBox.map(({ id, icon, title, paragraph }) => (
                <div key={id} className="text-center">
                  <div className="flex justify-center mb-3">
                    <div className="p-3 md:p-4 border-[4px] border-[#153088] rounded-full">
                      {icon}
                    </div>
                  </div>
                  <h2 className="text-sm md:text-sm lg:text-base font-semibold">{title}</h2>
                  <p className="px-12 md:px-0 text-xs md:text-sm">{paragraph}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
